import { gql } from "@apollo/client";

export const PROCESS_PUBLIC_TOKEN = gql`
  mutation processPublicToken($institutionId: String!, $publicToken: String!) {
    processPublicToken(input: { institutionId: $institutionId, publicToken: $publicToken })
  }
`;

export const LOGIN_USER = gql`
  mutation loginUser($email: String!, $password: String!) {
    loginUser(input: { email: $email, password: $password }) {
      sessionJwt
      sessionToken
    }
  }
`;

export const REGISTER_USER = gql`
  mutation registerUser($email: String!, $password: String!, $promotionCode: String) {
    registerUser(input: { email: $email, password: $password, promotionCode: $promotionCode }) {
      sessionJwt
      sessionToken
    }
  }
`;

export const INITIATE_LOGIN_WITH_PHONE = gql`
  mutation initiateLoginWithPhone($phoneNumber: String!) {
    initiateLoginWithPhone(input: { phoneNumber: $phoneNumber })
  }
`;

export const REGISTER_WITH_PHONE = gql`
  mutation registerWithPhone($email: String!, $phoneNumber: String!, $promotionCode: String) {
    registerWithPhone(
      input: { email: $email, phoneNumber: $phoneNumber, promotionCode: $promotionCode }
    )
  }
`;

export const LOGIN_WITH_PHONE = gql`
  mutation loginWithPhone($phoneNumber: String!, $code: String!, $email: String) {
    loginWithPhone(input: { phoneNumber: $phoneNumber, code: $code, email: $email }) {
      sessionJwt
      sessionToken
    }
  }
`;

export const LOGIN_WITH_OAUTH = gql`
  mutation loginWithOAuth($jwt: String!, $channel: OAuthChannel) {
    loginWithOAuth(input: { jwt: $jwt, channel: $channel }) {
      sessionJwt
      sessionToken
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation refreshToken($token: String!) {
    refreshToken(input: { token: $token }) {
      sessionJwt
      sessionToken
    }
  }
`;

export const INITIATE_RESET_PASSWORD = gql`
  mutation initiateResetPassword($email: String!) {
    initiateResetPassword(input: { email: $email })
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(input: { token: $token, password: $password })
  }
`;
